require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js
// module id = 81
// module chunks = 2